export * from "./page-not-found/page-not-found.component";
